import { createExchangeTokenRedirect } from '../../../admin-portal/src/services/exchangeTokenService.js'
import { TARGET_APPS } from '../../enums/target-apps.js'
import { showSnackbar } from '../../state/snackbar.js'
import { loadingSpinner } from '../../state/loading-spinner.js'

export const PRIVACY_NOTICE_NAVIGATION_TARGET_APP = TARGET_APPS.NOTICES
export const EXCHANGE_TOKEN_REDIRECT_ERROR_MESSAGE = 'Error authenticating portal access. Please try again later.'

export async function getPrivacyNoticeRedirectUrl () {
	const redirectUrl = await createExchangeTokenRedirect(TARGET_APPS.NOTICES)
	if (!redirectUrl) {
		console.error('[privacy-notice-navigation] exchange token redirect unavailable')
		showSnackbar({ text: EXCHANGE_TOKEN_REDIRECT_ERROR_MESSAGE, color: 'red' })
		return null
	}
	return redirectUrl
}

export async function navigateToPrivacyNoticePortal () {
	const redirectUrl = await getPrivacyNoticeRedirectUrl()
	if (!redirectUrl) {
		loadingSpinner.value = false
		return false
	}
	loadingSpinner.value = true
	window.location.href = redirectUrl
	return true
}
